<app-dialog-container>
    <div fxLayout="column" fxLayoutGap="16">
        <!-- Header -->
        <div fxLayout="row" fxLayoutAlign="space-between center"
            fxLayout.xs="column" fxLayoutGap.xs="8">
            <h2 mat-dialog-title class="modal-title">Transações - {{
                merchantName }}</h2>
        </div>

        <!-- Content -->
        <div fxLayout="column" fxLayoutGap="16"
            class="content-container">
            <div class="form-section">
                <form [formGroup]="form">
                    <div fxLayout="row"
                        fxLayoutWrap
                        fxLayout.lt-md="column"
                        fxLayoutGap="12"
                        fxLayoutAlign.lt-md="stretch">

                        <div fxFlex
                            fxFlex.lt-md="1 1 100%"
                            fxFlex.xs="1 1 100%">
                            <app-date-picker
                                [config]="getFieldConfig('startDate')"
                                [group]="form">
                            </app-date-picker>
                        </div>

                        <div fxFlex
                            fxFlex.lt-md="1 1 100%"
                            fxFlex.xs="1 1 100%">
                            <app-date-picker
                                [config]="getFieldConfig('endDate')"
                                [group]="form">
                            </app-date-picker>
                        </div>

                        <div fxFlex
                            fxFlex.lt-md="1 1 100%"
                            fxFlex.xs="1 1 100%">
                            <app-select
                                [config]="getFieldConfig('tipoDataPesquisa')"
                                [group]="form">
                            </app-select>
                        </div>

                        <div fxFlex="none"
                            fxLayoutAlign="end center"
                            fxLayoutAlign.lt-md="center center"
                            fxLayoutAlign.xs="stretch">
                            <button mat-raised-button
                                color="primary"
                                (click)="loadTransactions()"
                                [disabled]="form.invalid"
                                class="search-button"
                                fxFlex.xs="1 1 100%">
                                <span class="button-text">Buscar</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="table-section" fxLayout="column" fxLayoutGap="8">
                <div class="table-container" fxLayout="column">
                    <table-responsive
                        table
                        [length]="transactions.length"
                        [displayedColumns]="displayedColumns"
                        [dataSource]="dataSource"
                        [configColumns]="configColumns"
                        [hasAdd]="false"
                        [showLock]="false"
                        [isEditableShow]="false"
                        [isDeletableShow]="false"
                        [hideShowButton]="true"
                        class="responsive-table">
                    </table-responsive>
                </div>
            </div>
        </div>
    </div>
</app-dialog-container>